var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBarricade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_2116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.833 10.125H4.83301C4.21169 10.125 3.70801 10.6287 3.70801 11.25V21.375C3.70801 21.9963 4.21169 22.5 4.83301 22.5H31.833C32.4543 22.5 32.958 21.9963 32.958 21.375V11.25C32.958 10.6287 32.4543 10.125 31.833 10.125Z",
    stroke: "#4AC6FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1455 10.125L24.5205 22.5",
    stroke: "#4AC6FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2705 10.125L32.958 20.8125",
    stroke: "#4AC6FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.70801 11.8125L14.3955 22.5",
    stroke: "#4AC6FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.333 22.5V28.125",
    stroke: "#4AC6FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 22.5V28.125",
    stroke: "#4AC6FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_2116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    transform: "translate(0.333008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarricade);
export default __webpack_public_path__ + "static/media/icon-Barricade.2b68db4a6144c01313f655fae88024c6.svg";
export { ForwardRef as ReactComponent };